import axios from 'api/axios'
/**
 * Mark a document as readed
 *
 * @async
 * @param {number} document_id - The document id
 * @throws {Error} Can throw an error if the axios request fails
 */
export async function markComunicadoAsReaded(document_id) {
  const response = await axios.post('comunicados/marcarlectura/ ', { id: document_id })
  if (response.status !== 200) throw new Error('No se pudo marcar el comunicado como leido')
  return response.data
}
